// import React from 'react'
import React, { useState, createContext, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';

export const DataContext = createContext();

const DataProvider = (props: {}) => {
  const navigate = useNavigate();
  const [expiry, setExpiry] = useState(new Date().getTime() + 600000);
  const [listSections, setListSections] = useState([]);
  const [SearchResult, setSearchResult] = useState([]);
  const [searchParams, setsearchParams] = useSearchParams();
  const page: number | any = searchParams.get('page');
  const [subjectCode, setSubjectCode] = useState({});
  const [isLoading, setisLoading] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [FirstName, setFirstName] = useState('');
  const [LastName, setLastName] = useState('');
  const [pageCount, setpageCount] = useState(0);
  const [Email, setEmail] = useState('');
  const [ConfirmaPassword, setConfirmaPassword] = useState('');
  const [listSection, setListSection] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [ValueForSearch, setValueForSearch] = useState({});
  const [expire, setExpire] = useState(false);
  const [codeMozoeeDropdown, setCodeMozoeeDropdown] = useState(null);
  const [userIdentityIdDropdown, setUserIdentityIdDropdown] = useState('');

  // ----------------------------------------------------------------------------------------------------------------------------

  const isDevelopment = window.location.hostname === 'localhost';
  const cookieDomain = isDevelopment ? '.localhost' : '.ilaws.net';
  const DomainAsliOrLocal = isDevelopment
    ? 'http://localhost:3000'
    : 'https://ilaws.net';
  const DomainAsliOrLocalForLogin = isDevelopment
    ? 'http://localhost:3000/login'
    : 'https://ilaws.net/login';

  const [tokenLoginCookies, setTokenLoginCookies] = useState(() => {
    const userLogin = Cookies.get('token', {
      domain: cookieDomain,
      secure: !isDevelopment,
      sameSite: isDevelopment ? 'Lax' : 'Strict',
    });
    return userLogin ? JSON.parse(userLogin).data : null;
    // return userLogin ? JSON.parse(userLogin) : null;
    // return userLogin.data;
  });

  // const [tokenLoginCookies, setTokenLoginCookies] = useState({
  //   accessToken:
  //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIxMjA1ZmMxOC0wMjYyLTdmNGEtMTA4MS1mNzE5Y2EyNjJiMzAiLCJpc3MiOiJodHRwOi8vODUuMTk4LjkuODg6NzAwMCIsImlhdCI6MTc0MDQ5NDU1OCwidXNlck5hbWUiOiJoYW1pZHJlemFnaWxha2hvc3NlaW5pIiwiZGlzcGxheU5hbWUiOiJoYW1pZHJlemFnaWxha2hvc3NlaW5pIiwidXNlcklkIjoiMjFkNzA3ODktYTg1Ni00NWQzLWEzODItNTY2MWViMTI5ZDdhIiwidmVyaWZpZWQiOiJmYWxzZSIsImZpcnN0TmFtZSI6Itit2YXbjNiv2LHYttinIiwibGFzdE5hbWUiOiLar9uM2YTaqSDYrdiz24zZhtuMIiwicm9sZSI6IlN1cGVyQWRtaW4iLCJkeW5hbWljUGVybWlzc2lvbiI6WyI6UGVybWlzc2lvbjpQZXJtaXNzaW9uTGlzdCIsIjpQZXJtaXNzaW9uOkdldFBlcm1pc3Npb25CeUlkIiwiOlBlcm1pc3Npb246Q3JlYXRlUGVybWlzc2lvbiIsIjpQZXJtaXNzaW9uOkVkaXRQZXJtaXNzaW9uIiwiOlBlcm1pc3Npb246Q2hhbmdlUGVybWlzc2lvblN0YXR1cyIsIjpSb2xlOlJvbGVMaXN0IiwiOlJvbGU6R2V0Um9sZUJ5SWQiLCI6Um9sZTpHZXRSb2xlQnlOYW1lIiwiOlJvbGU6Q3JlYXRlUm9sZSIsIjpSb2xlOkVkaXRSb2xlIiwiOlJvbGU6Q2hhbmdlUm9sZVN0YXR1cyIsIjpSb2xlUGVybWlzc2lvbjpHZXRSb2xlUGVybWlzc2lvbkxpc3QiLCI6Um9sZVBlcm1pc3Npb246QWRkUGVybWlzc2lvblRvUm9sZSIsIjpSb2xlUGVybWlzc2lvbjpSZW1vdmVQZXJtaXNzaW9uRnJvbVJvbGUiLCI6Um9sZVBlcm1pc3Npb246Q2hhbmdlUm9sZVBlcm1pc3Npb25TdGF0dXMiLCI6VXNlcjpVc2VyTGlzdCIsIjpVc2VyOkdldFVzZXJCeUlkIiwiOlVzZXI6R2V0VXNlckJ5VXNlck5hbWUiLCI6VXNlcjpSZW1vdmVSb2xlRnJvbVVzZXIiLCI6VXNlcjpBZGRSb2xlVG9Vc2VyIiwiOlVzZXI6Q2hhbmdlUGFzc3dvcmRXaXRoVXNlck5hbWUiLCI6VXNlcjpDaGFuZ2VVc2VyU3RhdHVzIiwiOlVzZXI6SW5zZXJ0VXNlcldpdGhSb2xlcyIsIjpVc2VyUGVybWlzc2lvbjpHZXRVc2VyUGVybWlzc2lvbkxpc3QiLCI6VXNlclBlcm1pc3Npb246QWRkUGVybWlzc2lvblRvVXNlciIsIjpVc2VyUGVybWlzc2lvbjpSZW1vdmVQZXJtaXNzaW9uRnJvbVVzZXIiLCI6VXNlckx3U3ViamVjdDpTdWJqZWN0c1RyZWUiLCI6VXNlcjpHZXRVc2VyUm9sZXNCeVVzZXJJZCIsIjpVc2VyUGVybWlzc2lvbjpDaGFuZ2VVc2VyUGVybWlzc2lvblN0YXR1cyJdLCJleHAiOjE3NDA3NTM3NTksImF1ZCI6Ikxhd01pbmVyUGx1c0FwaSJ9.I9xaVGaZCI983KeRBS7kuqVI8XgiF4Z4aVbW1uBwh-Q',
  //   accessTokenExpiration: '2025-02-28T14:42:39.0064346Z',
  //   refreshToken:
  //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NDMwODY1NTksImlzcyI6Imh0dHA6Ly84NS4xOTguOS44ODo3MDAwIiwiYXVkIjoiTGF3TWluZXJQbHVzQXBpIn0.fm1pt-_VXHxh7BH0qcji8sxAGzX-A5TKmvZbwu2mf-U',
  //   refreshTokenExpiration: '2025-03-27T14:42:39.0099316Z',
  // });

  // console.log('tokenLoginCookies', tokenLoginCookies);
  // if (window) {
  //   // console.log('window.location.hostname', window.location.hostname);
  // }

  const [booksData, setBooksData] = useState([]);
  const [topicsData, setTopicsData] = useState([]);
  const [bookMarksData, setBookMarksData] = useState([]);

  // --------------------------------------------------------------------------------------------------------------------------------
  const [typeIdTitSub, setTypeIdTitSub] = useState([]);
  const [statusExeAndApr, setStatusExeAndApr] = useState([]);
  const [titSubParentID, setTitSubParentID] = useState(0);
  const [toggleSabt, setToggleSabt] = useState(true);
  const [ParentId, setParentId] = useState<null | Number>();
  // const [pIdChapter, setPIdChapter] = useState(null);
  const [pIdChapter, setPIdChapter] = useState(17);
  const [chapterSectionText, setChapterSectionText] = useState([]);
  const [executivSectionText, setExecutivSectionText] = useState([]);

  // const [dataHomePage, setDataHomePage] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tokenLoginCookies) {
      // window.location.href = 'https://ilaws.net';
      console.log('tokenLoginCookies---------->', tokenLoginCookies);
      alert('لطفا از سایت اصلی وارد حساب کاربری خود شوید');
      window.location.href = DomainAsliOrLocalForLogin;

      // window.location.href = DomainAsliProfileOrLocal;
    }
  }, []);
  // }, [tokenLoginCookies]);

  // اضافه کردن state جدید برای کنترل حالت سایدبار
  const [sidebarMode, setSidebarMode] = useState<'full' | 'mini' | 'closed'>(
    'full',
  );

  // تابع تغییر حالت سایدبار
  const toggleSidebarMode = () => {
    setSidebarMode((current) => {
      if (current === 'full') return 'mini';
      if (current === 'mini') return 'closed';
      return 'full';
    });
  };

  // const ChangePassword = (obj: {}) => {
  //   console.log(obj);
  //   fetch(`${process.env.REACT_APP_BASE_URL_Profile}/v1/User/ChangePassword`, {
  //     method: 'POST',
  //     headers: {
  //       Authorization: `Bearer ${tokenLoginCookies?.accessToken}`,
  //       'Content-Type': 'application/json',
  //       accept: 'text/plain',
  //       // 'Access-Control-Allow-Origin': '*',
  //       // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
  //       // 'Access-Control-Allow-Headers':
  //       //   'X-Requested-With, Content-Type, Authorization',
  //       // 'Access-Control-Allow-Credentials': 'true',
  //     },
  //     body: JSON.stringify({
  //       oldPassword: obj.oldPassword,
  //       newPassword: obj.password,
  //       confirmPassword: obj.confirmPassword,
  //     }),
  //   }).then((res) => {
  //     console.log('res --> change password', res);

  //     if (res.status == 200) {
  //       alert('عملیات با موفقیت انجام شد');
  //     } else {
  //     }
  //   });
  // };

  const ChangePassword = async (obj: {
    oldPassword: string;
    password: string;
    confirmPassword: string;
  }) => {
    // Add loading state
    setisLoading(true);

    // Input validation
    if (!obj.oldPassword || !obj.password || !obj.confirmPassword) {
      console.log(
        '!obj.oldPassword --->',
        obj.oldPassword,
        ' !obj.password --->',
        obj.password,
        ' !obj.confirmPassword --->',
        obj.confirmPassword,
      );

      alert('لطفا تمام فیلدها را پر کنید');
      setisLoading(false);
      return;
    }

    // Password match validation
    if (obj.password !== obj.confirmPassword) {
      alert('رمز عبور جدید و تکرار آن مطابقت ندارند');
      setisLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_Profile}/v1/User/ChangePassword`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${tokenLoginCookies?.accessToken}`,
            'Content-Type': 'application/json',
            accept: 'text/plain',
          },
          body: JSON.stringify({
            oldPassword: obj.oldPassword,
            newPassword: obj.password,
            confirmPassword: obj.confirmPassword,
          }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        alert('تغییر رمز عبور با موفقیت انجام شد');
        return true;
      } else {
        alert(data.message || 'خطا در تغییر رمز عبور');
        return false;
      }
    } catch (error) {
      console.error('Error changing password:', error);
      alert('خطا در ارتباط با سرور');
      return false;
    } finally {
      setisLoading(false);
    }
  };

  const handlePasswordChange = async () => {
    const success = await ChangePassword({
      oldPassword: 'currentPassword',
      password: 'newPassword',
      confirmPassword: 'newPassword',
    });

    if (success) {
      // Handle successful password change
    }
  };

  const [tokenLogin, setTokenLogin] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedValueToken = localStorage.getItem('tokenLogin');
      return storedValueToken ? JSON.parse(storedValueToken) : '';
    } else {
      return '';
    }
  });

  // const fetchLoginJWT = async () => {
  //   setisLoading(true);
  //   try {
  //     // console.log(email, password);
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL_Profile}/v1/Account/Login`,
  //       {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           // 'Access-Control-Allow-Origin': '*',
  //           // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
  //           // 'Access-Control-Allow-Headers':
  //           //   'X-Requested-With, Content-Type, Authorization',
  //           // 'Access-Control-Allow-Credentials': 'true',
  //         },
  //         body: JSON.stringify({
  //           UserName: `${username}`,
  //           Password: `${password}`,
  //         }),
  //       },
  //     );
  //     // console.log(response);
  //     const token = await response.json();
  //     console.log(token);

  //     setisLoading(false);
  //     if (
  //       token[0] == 'Password : The Password field is required.' ||
  //       token[0] == 'user not found' ||
  //       token[0] == 'UserName : The UserName field is required.'
  //     ) {
  //       alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
  //     } else {
  //       setTokenLogin(token);
  //       const decode = jwtDecode(token.data?.accessToken);
  //       localStorage.setItem('username', decode.userName);
  //       // setEdame(true);
  //       window.location.assign('/home');
  //       console.log('token Is True');
  //     }
  //   } catch (error) {
  //     console.log('errorFetchLoginJWT', error);
  //   }
  // };

  const expireToken = (tokenProp) => {
    try {
      const decoded = jwtDecode(tokenProp);
      if (decoded.exp < Date.now() / 1000) {
        localStorage.setItem('tokenexpire', JSON.stringify(true));
        setExpire(true);
        return true;
      } else {
        localStorage.setItem('tokenexpire', JSON.stringify(false));
        setExpire(false);
        return false;
      }
    } catch (err) {
      return false;
    }
  };
  const isTokenExpired = (tokenProp) => {
    try {
      const decoded = jwtDecode(tokenProp);
      // console.log(decoded.exp < Date.now() / 1000);
      if (decoded.exp < Date.now() / 1000) {
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  };

  const fetchRefreshToken = async () => {
    if (!tokenLoginCookies?.accessToken || !tokenLoginCookies?.refreshToken) {
      console.log('Missing tokens: cannot refresh');
      return;
    }
    let usernameFromToken = '';
    try {
      const decoded: any = jwtDecode(tokenLoginCookies.accessToken);
      usernameFromToken = decoded?.userName || '';
    } catch (e) {
      console.log('Invalid access token, cannot decode', e);
      return;
    }
    setisLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/user/RefreshToken`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Token: `${tokenLoginCookies.refreshToken}`,
            UserName: `${usernameFromToken}`,
          }),
        },
      );
      if (response.status === 200) {
        const token = await response.json();
        setTokenLogin(token);
        localStorage.setItem('tokenLogin', JSON.stringify(token));
      } else {
        console.log('error', response);
        setTokenLogin('');
        localStorage.setItem('tokenLogin', JSON.stringify(''));
      }
    } catch (error) {
      console.log('errorFetchRefreshToken', error);
    } finally {
      setisLoading(false);
    }
  };
  const [TypeIDList, setTypeIDList] = useState([]);

  const Register = (obj: {}) => {
    console.log(obj);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/Accounts/Register`,

      headers: {
        // Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
        // 'Access-Control-Allow-Headers':
        //   'X-Requested-With, Content-Type, Authorization',
        // 'Access-Control-Allow-Credentials': 'true',
      },
      data: JSON.stringify({
        UserName: obj.Username,
        Email: obj.email,
        Password: obj.Password,
        ConfirmPassword: obj.confirmPassword,
        FirstName: obj.firstName,
        LastName: obj.lastName,
      }),
    };
    // console.log(obj);
    if (obj.Password === obj.confirmPassword) {
      axios
        .request(config)
        .then((res) => {
          if (res.status == 200) {
            alert('کاربر با موفقیت ثبت نام شد ');
            // navigate('/');
          } else {
            console.log(res);
            console.log(res);
          }
        })

        .then(function (response) {
          if (response) {
            console.log('response', response);
          }
        })
        .catch(function (error) {
          if (error) {
            console.log('error', error);
          }
        });
    } else {
      alert('پسورد را تایید کنید');
    }
  };

  const Logout = () => {
    // console.log('object');
    // fetch(`${process.env.REACT_APP_BASE_URL}/api/Accounts/Logout`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${tokenLoginCookies?.accessToken}`,
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
    // 'Access-Control-Allow-Headers':
    //   'X-Requested-With, Content-Type, Authorization',
    // 'Access-Control-Allow-Credentials': 'true',
    //   },
    // })
    //   .then(function (response) {
    //     if (response) {
    localStorage.clear();
    // localStorage.clear();
    // localStorage.removeItem('tokenLogin');
    // // localStorage.removeItem('edame');
    // localStorage.removeItem('username');
    setisLoading(false);
    window.location.assign(`${DomainAsliOrLocal}`);
    // console.log('response', response);
    //   }
    // })
    // .catch(function (error) {
    //   if (error) {
    //     console.log('error', error);
    //   }
    // });
  };

  const checkEdame = () => {
    if (isTokenExpired(tokenLogin.data?.accessToken)) {
      if (isTokenExpired(tokenLogin?.RefreshToken)) {
        // setEdame(false);

        console.log('edame false');

        // localStorage.setItem('edame', JSON.stringify(edame));
      } else {
        console.log('edame with refreshToken');

        fetchRefreshToken();
      }
    } else {
      try {
        console.log('check edame true ');

        // localStorage.setItem('edame', JSON.stringify(edame));
      } catch (error) {
        console.log('errorFetchAllData222222222222', error);
      }
    }
  };
  const [TypeList, setTypeList] = useState([]);
  return (
    <DataContext.Provider
      value={{
        // pageCount,
        // isLoading,
        // fetchPage

        setUserInfo,
        userInfo,
        setUserName,
        setPassword,
        username,
        password,
        // login,
        expire,
        Register,
        Logout,
        // token,
        expireToken,
        listSection,

        // fetchLoginJWT,
        tokenLogin,
        setTokenLogin,
        expiry,
        setExpiry,
        checkEdame,
        isTokenExpired,
        fetchRefreshToken,
        // caseData,
        // setcaseData,
        // ReformInfo,
        // setReformInfo,
        // OptionSearch,
        // setOption,
        // orgId,
        // setOrgId,
        // orgId2,
        // setOrgId2,
        isLoading,
        setisLoading,
        ValueForSearch,
        setValueForSearch,
        TypeList,
        setTypeList,
        // fetchListReSection,
        loading,
        setLoading,
        // listReSection,
        // setListReSection,
        // fetchListSection,
        listSections,
        setListSections,
        TypeIDList,
        setTypeIDList,

        // listSections,
        // setListSections,

        // titleSubInfo,
        // setTitleSubInfo,
        titSubParentID,
        setTitSubParentID,

        typeIdTitSub,
        setTypeIdTitSub,

        // titSubID,
        // setTitSubID,
        ChangePassword,
        // AddRole,
        // DeleteRole,
        // titExecutive,
        // setTitExecutive,

        // toggleDToM,
        // setToggleDToM,

        executivSectionText,
        setExecutivSectionText,
        statusExeAndApr,
        setStatusExeAndApr,

        toggleSabt,
        setToggleSabt,

        pIdChapter,
        setPIdChapter,
        // titChapterInfo,
        // setTitChapterInfo,
        chapterSectionText,
        setChapterSectionText,

        // emptySearchText,
        // setEmptySearchText,
        ParentId,
        setParentId,

        sidebarMode,
        setSidebarMode,
        toggleSidebarMode,

        booksData,
        setBooksData,
        topicsData,
        setTopicsData,
        bookMarksData,
        setBookMarksData,

        tokenLoginCookies,
        setTokenLoginCookies,
        codeMozoeeDropdown,
        setCodeMozoeeDropdown,
        userIdentityIdDropdown,
        setUserIdentityIdDropdown,
        // dataHomePage,
        // setDataHomePage,
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
};

export default DataProvider;
